module.exports = "/** \r\n* Stadium Module\r\n*/\r\n.bgm-red{\r\n    background-color:#ad1115!important\r\n  }\r\n.c-red{\r\n    color:#ad1115!important\r\n  }\r\n.card-stadium-body img {\r\n    max-width: 100%;\r\n  }\r\n.stadium-city{\r\n    color:rgba(255,255,255,.6);\r\n    font-size:15px\r\n  }\r\n.stadium-title{\r\n    font-size:25px;\r\n    line-height:100%;\r\n    color:#fff\r\n  }\r\n.card-stadium{\r\n      padding: 10px 30px;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/stadiums/stadiums.component.css
// module id = ./src/app/components/stadiums/stadiums.component.css
// module chunks = main